import header_baner from "../../../assets/images/header_img.svg";
import header_baner2 from "../../../assets/images/header_baner2.svg";
import logo from "../../../assets/images/logo.svg";
import Container from "../../../components/container";
import deposit from "../../../assets/images/deposit.svg";
import line from "../../../assets/images/line_section1.svg";
import MobileToggleBtn from "../../../components/header/mobile_toggle_btn";

export default function Section1({ isOpen, toggleSidebar }) {
    return (
        <section className="section1 pt-[21px] md:pt-[32px] lg:pt-[64px]">
            <Container className="!mb-[60px] !px-[30px] lg:!px-[40px] 2xl:!px-0">
                <div className="relative flex flex-col w-full">
                    <div className="flex items-center justify-between lg:justify-start">
                        <img src={logo} alt="logo" className="header_logo" />
                        <div className="hidden md:flex items-center ml-[43px] ">
                            <span className="text-[#000000] font-bold text-[16px] cursor-pointer hover:opacity-70"
                                onClick={() => {
                                    const element = document.getElementById("what-we-do");
                                    const offset = 50;

                                    if (element) {
                                        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                                        window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
                                    }
                                }}
                            >What we Do</span>
                            <div className="bg-[#00B5EA] w-[20px] h-[2px] ml-[10px] mr-[9px]"></div>
                            <span className="text-[#000000] font-bold text-[16px] cursor-pointer hover:opacity-70"
                                onClick={() => {
                                    const element = document.getElementById("our-works");
                                    const offset = 80;

                                    if (element) {
                                        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                                        window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
                                    }
                                }}
                            >Our Works</span>
                            <div className="bg-[#00B5EA] w-[20px] h-[2px] ml-[10px] mr-[9px]"></div>
                            <span className="text-[#000000] font-bold text-[16px] cursor-pointer hover:opacity-70"
                                onClick={() => document.getElementById('contacts').scrollIntoView({ behavior: "smooth", duration: 500 })}

                            >Contacts</span>
                        </div>
                        <MobileToggleBtn
                            toggleSidebar={toggleSidebar}
                            isOpen={isOpen}
                            dark={true}
                        />
                    </div>
                </div>
            </Container>
            <div className="relative w-full">
                <Container className="!px-0 sm:!px-[30px] lg:pl-[40px] lg:!pr-0">
                    <div className="flex w-full bg-[#004D99] h-[680px] xs:h-[640px] md:h-[790px] lg:h-[700px] lg:rounded-tl-[351px] lg:rounded-bl-[351px] rounded-tl-[500px] rounded-tr-[500px]">
                        <div className="relative h-full w-full flex flex-col lg:justify-start lg:flex-row items-center top-0">
                            <div className="deposit !z-20 flex flex-none justify-between">
                                <div className="absolute w-[300px] h-[244px] ssm:w-full ssm:h-full md:w-[585px] md:h-[476px] 2xl:w-[726px] 2xl:h-[591px] top-[13px] md:top-[20px] left-1/2 transform -translate-x-1/2 lg:left-[-83px] 2xl:left-[-59px] lg:translate-x-0 top-[-17px] 2xl:top-[35px]">
                                    <img src={deposit} alt="deposit" className="w-full h-full" style={{ objectFit: "contain" }} />
                                </div>
                            </div>
                            <div className="z-20 absolute bottom-[52px] lg:top-0 2xl:right-[-28px] lg:right-[40px] flex flex-col lg:h-full lg:pt-[159px] w-full px-[30px] md:px-0 md:w-[660px] lg:w-[461px] 2xl:!w-[471px] right-1/2 transform translate-x-1/2 lg:translate-x-0">
                                <h4 className="text-center lg:text-left text-[#EB4A00] text-[24px] md:text-[32px] lg:text-[40px] leading-[30px] md:leading-[40px] lg:leading-[50px] font-bold">
                                    Cloud Apps AI and <br className="md:hidden lg:block" />Games development
                                </h4>
                                <p className="mt-[19px] lg:mt-[39px] text-[14px] md:text-[16px] lg:text-[18px] text-white leading-[25px] md:leading-[30px] font-normal text-center lg:text-left">We design, build, and scale high-quality mobile games and AI-powered cloud applications for a global audience. From idea to live operations, Ultranex delivers fast, stable releases and long-term growth.</p>
                                <img src={line} alt="line" className="w-full mt-[20px] lg:mt-[49px]"
                                    style={{ objectFit: "cover" }}
                                />
                            </div>
                            <div className="absolute top-[-250px] right-0 hidden 2xl:block w-[372px] h-[379px] 2xl:w-[460px] 2xl:h-[460px] -z-10">
                                <img src={header_baner} alt="header_baner" className="w-full h-full"
                                    style={{ objectFit: "contain" }}
                                />
                            </div>
                            <div className="absolute top-[-230px] right-0 hidden lg:block 2xl:hidden w-[372px] h-[379px] 2xl:w-[460px] 2xl:h-[460px] -z-10">
                                <img src={header_baner2} alt="header_baner" className="w-full h-full"
                                    style={{ objectFit: "contain" }}
                                />
                            </div>
                            <div className="effect_right1 absolute bottom-[-40px] right-[153px] z-10 hidden lg:block"></div>
                            <div className="effect_right2 absolute bottom-[-40px] right-0 z-10 hidden lg:block"></div>
                        </div>
                    </div>
                </Container>
                <div className="absolute top-0 right-0 z-10 effect_left hidden 2xl:block"></div>
                <div className="absolute top-0 right-[-360px] z-10 effect_left_lg hidden lg:block 2xl:hidden"></div>
                <div className="absolute h-[700px] top-0 right-0 bg-[#004D99] w-1/2 -z-10 hidden lg:block"></div>
            </div>
        </section>);
}